// extracted by mini-css-extract-plugin
export var button = "bZ_qz";
export var button__darkBlue = "bZ_qF";
export var button__edgesGrey = "bZ_qG";
export var button__edgesRed = "bZ_qC";
export var button__loader = "bZ_qH";
export var button__red = "bZ_qB";
export var button__transparent = "bZ_qD";
export var loadingSpinner = "bZ_qJ";